import type { ReactNode } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

import { isSameDay } from '#utils/isSameDay.ts';

type OrderLocationProps = {
    street?: string;
    zipCode?: string;
    city?: string;
    name: ReactNode;
    from: string;
    to: string;
    country?: string;
};

export const Location = ({ name, street, zipCode, city, from, to, country }: OrderLocationProps) => {
    const sameDay = isSameDay(from, to);
    const showToDate = from !== to && !sameDay;
    const showToTime = from !== to;

    return (
        <div className='display-flex flex-column gap-2 max-width-400'>
            <div className='text-bold text-size-16 line-height-18 ellipsis-1'>{name}</div>

            <div className={'text-medium ellipsis-1'}>
                {country} - {zipCode} {city}, {street}
            </div>

            <div className='display-flex align-items-center gap-10 ellipsis-1 '>
                <div className='display-flex align-items-center gap-2'>
                    <span className='uikit-icon icon-calendar text-color-darker' />
                    <span>
                        <FormattedDate value={from} />
                    </span>
                </div>
                <div className='display-flex align-items-center gap-2'>
                    <span className='uikit-icon icon-time-alt text-color-darker' />
                    <span>
                        <FormattedTime value={from} />
                    </span>
                </div>
                {showToDate && (
                    <>
                        <span className='margin-x-2'>—</span>
                        <div className='display-flex align-items-center gap-2'>
                            <span className='uikit-icon icon-calendar text-color-darker' />
                            <span>
                                <FormattedDate value={to} />
                            </span>
                        </div>
                    </>
                )}
                {showToTime && (
                    <>
                        {sameDay && <span className='margin-x-2'>—</span>}
                        <div className='display-flex align-items-center gap-2'>
                            <span className='uikit-icon icon-time-alt text-color-darker' />
                            <span>
                                <FormattedTime value={to} />
                            </span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
